import React from "react";
import CoreTypographyBody1 from "./CoreTypographyBody1";
import { Box } from "@mui/material";
import CoreTypographyCaption from "./CoreTypographyCaption";

export default function CustomView({ label, value }) {
  return (
    <>
      <Box>
        <CoreTypographyBody1 style={{ fontWeight: "bold" }}>
          {label}
        </CoreTypographyBody1>
      </Box>
      <Box>
        <CoreTypographyCaption>{value}</CoreTypographyCaption>
      </Box>
    </>
  );
}
